import React, { useState, useEffect, Suspense } from 'react'
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom'
import { ReactSession } from 'react-client-session';
import axios from 'axios'

import Header from '../../Header/Header';
import Sidebar from '../../Sidebar/Sidebar';
import Loader from '../../Global/Loader';

import styles from '../../../App.module.css';
import classes from './AddWebGroup.module.css'
import Tabs from '../Tabs/Tabs';

import noThumb from "../../../images/no-thumb.jpg";

function AddWebGroup() {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    // const [webGroup, setWebGroup] = useState([]);
    
    const [image, setImage] = useState('');
    const [thumb, setThumb] = useState(null);
    const [privacy, setPrivacy] = useState(true);
    const [ifDisabled, setIfDisabled] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState({
        status: false,
        message: ''
    });
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        !logged_user && navigate('/login');
    } , [])

    const onSubmit = (e) => {
        setIfDisabled(true);

        const data = new FormData();
        data.append('uid', logged_user);
        data.append('play-name', e.title);
        data.append('description', e.description);
        data.append('tags', e.tags);
        data.append('private', e.private);
        data.append('play-img', thumb);

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/addwebgroup.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(res => {
                // console.log(res.data);
                setIsSubmitted({
                    status: true,
                    type: res.data.status,
                    message: res.data.message
                });

                setIfDisabled(false);
            }).catch(err => {
                console.log(err);
            })
    }

    const onImageChange = (e) => {
        setThumb(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setImage('');
        }
    }

    const handlePrivacy = (e) => {
        if(e.target.value === '1') {
            setPrivacy(false);
        } else {
            setPrivacy(true);
        }
    }

    return (
        <>
            <Header />
            <div className={styles.main_body}>
            <Suspense fallback="<div>Please wait...</div>">
                <Sidebar />
            </Suspense>
            <Suspense fallback="<div>Please wait...</div>">
                <div className={styles.main_content + ` main-content`}>
                    <div className={classes.video_component + ` p-4`}>
                        <Tabs active="addwebgroup" />
                        <div className={classes.panel}>
                            <div className={classes.panel_body}>
                                {
                                    !isSubmitted.status ? <div className="row">
                                        <div className="col-8">
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="form-group">
                                                    <label>Title:</label>
                                                    <input {...register('title', {required: true})} className="form-control" type="text" placeholder="Your Group's Title" />
                                                    {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                </div>
                                                <div className="form-group">
                                                    <label>Website Description:</label>
                                                    <textarea {...register('description')} className="form-control" rows="3" placeholder="Your Group's Description"></textarea>
                                                </div>
                                                <div className="form-group">
                                                    <label>Group Thumbnails (350px X 250px):</label>
                                                    <input className="form-control" type="file" onChange={onImageChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Show group ?</label>
                                                    <div className={`form-group ${classes.radio}`}>
                                                        <label className="radio inline">
                                                            <input {...register('private')} type="radio" className="styled" value="0" checked={privacy} onClick={handlePrivacy} />Public
                                                        </label>
                                                        <label className="radio inline">
                                                            <input {...register('private')} type="radio" className="styled" value="1" checked={!privacy} onClick={handlePrivacy} />Private
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className={`form-group ${styles.btn_flex}`}>
                                                    <button className="btn btn-primary" type="submit" disabled={ifDisabled}>{ifDisabled ? 'Creating Group' : 'Create Group'}</button>
                                                    {
                                                        ifDisabled && <Loader />
                                                    }
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-4">
                                            <div className={`${classes.group_thumb} mt-4 mb-3`}>
                                                <label htmlFor="">Thumbnail:</label>
                                                <img width="100%" src={image} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                            </div>
                                        </div>
                                    </div>
                                    : <div className='mt-4'>
                                        <div class={`alert alert-${isSubmitted.type}`} role="alert">{isSubmitted.message}</div>
                                        {
                                            isSubmitted.type === 'success' && <div className="align-center" align="center">
                                                <Link to="/dashboard/groups" className="btn btn-primary">Manage media.</Link>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Suspense>
            </div>
        </>
    )
}

export default AddWebGroup